
export default {
    props   : ['money', 'short']
}
